export default "__VITE_ASSET__CzfhVM$c__"